


















































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {EmployeeStore} from "@/modules/employees/store";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {CommonStatus} from "@/enums/status";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
// import WardSelector from "@/modules/regions/WardSelector/index.vue";
import UploadImage from "@/shared/components/UploadImage/Index.vue";
import {PHONE_REGEX} from "@/shared/constant";
import {AuthStore} from "@/modules/auth/store";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import ATextareaCustom from "@/shared/components/TextAreaAntCustom/index.vue";

@Component({
  name: "EmployeeForm",
  components: {
      ATextareaCustom,
      AInputCustom,
    InputCurrency,
    UploadImage,
    // WardSelector,
    PostOfficeSelector, MillisecondDatePicker, DistrictSelector, ProvinceSelector, EnumSelector
  },
})
export default class extends mixins(CommonMixin) {
  @Prop()
  readonly id!: string;

  EmployeeType = EmployeeType;
  CommonStatus = CommonStatus;
  private form = {
    rowGuid: "",
    username: "",
    password: undefined,
    employeeCode: "",
    avatar: "",
    avatarUrl: "",
    fullname: "",
    phoneNumber: "",
      bankAccount: "",
      bankName: "",
    address: "",
    // wardId: undefined,
    districtId: undefined,
    provinceId: undefined,
    contractCode: "",
    workStartDate: undefined,
    workEndDate: undefined,
    contact: "",
    postOfficeRowGuid: undefined,
    status: undefined,
    type: undefined,
    mission: "",
    function: "",
    jurisdiction: "",
    note: "",
    bail: undefined
  };

  private rules = {
    username: [{required: true, message: "Nhập tài khoản", trigger: "change"}],
    password: [{required: true, message: "Nhập mật khẩu", trigger: "change"}],
    employeeCode: [{required: true, message: "Nhập mã nhân viên", trigger: "change"}],
    avatar: [{required: false}],
    fullname: [{required: true, message: "Nhập tên", trigger: "change"}],
    phoneNumber: [
      {required: true, message: "Nhập số điện thoại", trigger: "change"},
      {pattern: new RegExp(PHONE_REGEX), message: "Số điện thoại không đúng định dạng", trigger: "change"}
    ],
    address: [{required: true, message: "Nhập địa chỉ", trigger: "change"}],
    // wardId: [{required: true, message: "Chọn phường/xã", trigger: "change"}],
    districtId: [{required: true, message: "Chọn phường/xã", trigger: "change"}],
    provinceId: [{required: true, message: "Chọn tỉnh/tp", trigger: "change"}],
    contractCode: [{required: true, message: "Nhập mã hợp đồng", trigger: "change"}],
    workStartDate: [{required: true, message: "Chọn ngày bắt đầu làm việc", trigger: "change"}],
    workEndDate: [{required: false}],
    contact: [{required: false, message: "Nhập người khi cần liên hệ", trigger: "change"}],
    postOfficeRowGuid: [{required: false, message: "Chọn bưu cục", trigger: "change"}],
    status: [{required: false}],
    type: [{required: true, message: "Chọn chức vụ", trigger: "change"}]
  };

  private onSubmit() {
    (this.$refs.formEmployee as FormModel).validate(async valid => {
      if (!valid) return;
      try {
        this.id
            ? await EmployeeStore.updateEmployee(this.form)
            : await EmployeeStore.createEmployee(this.form);
        this.$notification.success({
          message: "Thành công",
          description: `${this.id ? 'Sửa' : 'Tạo'} nhân viên thành công`
        });
        this.$router.push({name: "listEmployees"});
      } catch (e) {
        this.$notification.error({
          message: "Thất bại",
          description: `${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} nhân viên thất bại`}`
        })
      }
    })
  }

  async created() {
    if (this.id) {
      this.rules.password = [{required: false} as any];
      try {
        const data = await EmployeeStore.singleEmployee(this.id);
        this.form = assignValueToForm(this.form, data);
      } catch (e) {
        this.$notification.error({
          message: "Thất bại",
          description: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
        })
      }
    }
  }
}
